import { BNHeader, BNJumpToNavigation, BNTopNavigation, OtherLanguage } from "@bn-monorepo/js-packages";
import { HeaderCms, HeaderData, getMessages } from "../CmsContent/services";
import React, { useContext, useEffect, useState } from "react";

import { SettingsContext } from "../../settingsContext";
import { useTheme } from "@mui/material";

interface Props {
  header: HeaderCms;
  headerData: HeaderData;
  otherLanguage?: OtherLanguage;
}

const HeaderMenu: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { header, headerData, otherLanguage } = props;
  const { resolveUrl, isApp, isAuthenticated, localization } = useContext(SettingsContext);
  const [messageList, setMessageList] = useState([] as any[]);
  const { strings, homeLink, userNavigationLinks, settingsLinks } = headerData;
  useEffect(() => {
    if (isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getMessages().then((data) => {
        setMessageList(data.messageList);
      });
    }
  }, [headerData]);

  if (!header) {
    return null;
  }

  const { menuLinks: menuLinksAnonymous } = header;

  const mapNavigationLinks = (links) =>
    links.map((x) => ({
      title: x.name,
      url: resolveUrl(x.url),
    }));
  const umbracoIsSpa = (x: any) => ["Internal", "Content"].some((type) => x && type === x.type);
  const navigationLinkIsSpa = (umbracoLinks) => (path: string) =>
    umbracoIsSpa(umbracoLinks.find((umbracoLink) => resolveUrl(umbracoLink.url) === path));
  return isAuthenticated ? (
    <>
      <BNJumpToNavigation jumpToNavigationString={localization?.jumpToNavigation} />
      <BNHeader
        homeLink={homeLink}
        userNavigationLinks={userNavigationLinks}
        settingsLinks={settingsLinks}
        isLoggedIn={true}
        altLinkText={localization?.goToFrontPage}
        otherLanguage={
          otherLanguage
            ? {
                ...otherLanguage,
                url: resolveUrl(otherLanguage.url),
              }
            : undefined
        }
        messageList={messageList}
        strings={{
          Account: strings.account,
          Notification: strings.notification,
          BNLogoAltTextLoggedIn: strings.bnLogoAltTextLoggedIn,
          loginLabel: header.loginLabel,
          darkModePrimaryText: strings.darkModePrimaryText,
          darkModeSecondaryText: strings.darkModeSecondaryText,
        }}
        loginLink={header.loginLink}
        headerDesktopPaddingX={1}
        headerMaxWidth="122.8rem"
        isSpa={() => false}
        isApp={isApp}
        isSticky={isAuthenticated}
      >
        <BNTopNavigation
          links={headerData.topNavigationLinks}
          isSpa={() => false}
          isAppLook={isApp}
          sx={
            isApp
              ? {
                  [theme.breakpoints.down("md")]: {
                    display: "none",
                  },
                }
              : undefined
          }
        />
      </BNHeader>
    </>
  ) : (
    <>
      <BNJumpToNavigation jumpToNavigationString={localization?.jumpToNavigation} />
      <BNHeader
        homeLink={homeLink}
        isLoggedIn={false}
        levelUpLink={{
          title: "",
          url: "",
          hiddenOnDesktop: true,
          hiddenOnMobile: true,
        }}
        otherLanguage={
          otherLanguage
            ? {
                ...otherLanguage,
                url: resolveUrl(otherLanguage.url),
              }
            : undefined
        }
        messageList={messageList}
        altLinkText={localization?.goToFrontPage}
        strings={{
          Account: strings.account,
          Notification: strings.notification,
          BNLogoAltTextLoggedIn: strings.bnLogoAltTextLoggedIn,
          loginLabel: header.loginLabel,
          darkModePrimaryText: strings.darkModePrimaryText,
          darkModeSecondaryText: strings.darkModeSecondaryText,
        }}
        loginLink={header.loginLink}
        headerDesktopPaddingX={1}
        headerMaxWidth="122.8rem"
        isSpa={() => false}
        isApp={isApp}
        isSticky={isAuthenticated}
      >
        <BNTopNavigation
          links={mapNavigationLinks(menuLinksAnonymous)}
          isSpa={navigationLinkIsSpa(menuLinksAnonymous)}
          isAppLook={isApp}
        />
      </BNHeader>
    </>
  );
};

export default HeaderMenu;
